export default {
    home: 'Home',
    dashboard: 'Dashboard',
    users: 'Nutzer',
    organisations: 'Lieferanten',
    company: 'Mein Unternehmen',
    settings: 'Einstellungen',
    myProfile: 'Mein Profil',
    information: 'Informationen',
    secret: 'Geheimnis',
    nothingToSeeHere: 'Hier gibt es nichts zu sehen 🙈',
    escapeRoom: '//farbcode Dungeon Escape! 🏰',
    dungeon: 'Dungeon',
    overview: 'Input-Übersicht',
    logout: 'Logout',
    baseData: 'Stammdaten',
    categories: 'Kategorien',
    loginProviders: 'Login Methoden',
    orders: 'Beschaffungen',
    costCenters: 'Kostenstellen',
    mailTemplates: 'Mail Vorlagen',
    tenders: 'Anfragen',
}
